var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 357,
    viewBox: "0 0 1440 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter0_f_346_106)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.974,
    cy: 292.673,
    rx: 173.974,
    ry: 292.673,
    transform: "matrix(0.612092 -0.790787 -0.989569 -0.144059 928.241 472.477)",
    fill: "#6B68FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter1_f_346_106)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.382,
    cy: 214.292,
    rx: 127.382,
    ry: 214.292,
    transform: "matrix(0.612092 -0.790787 -0.989569 -0.144059 1496.11 452)",
    fill: "#8EDCAD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter2_f_346_106)"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.382,
    cy: 214.292,
    rx: 127.382,
    ry: 214.292,
    transform: "matrix(0.612092 -0.790787 -0.989569 -0.144059 1233.77 452)",
    fill: "#8A55F8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter3_f_346_106)"
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.84,
    cy: 238.311,
    rx: 126.84,
    ry: 238.311,
    transform: "matrix(0.612092 -0.790787 -0.989569 -0.144059 534.328 459.183)",
    fill: "#8EDCAD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter4_f_346_106)"
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.278,
    cy: 136.254,
    rx: 123.278,
    ry: 136.254,
    transform: "matrix(0.612092 -0.790787 -0.989569 -0.144059 161.665 452)",
    fill: "#8A55F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_346_106",
    x: 288.52,
    y: 0.88118,
    width: 913.176,
    height: 583.714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 73.9636,
    result: "effect1_foregroundBlur_346_106"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_346_106",
    x: 988.101,
    y: 67.0863,
    width: 747.851,
    height: 506.622,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 73.9636,
    result: "effect1_foregroundBlur_346_106"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_346_106",
    x: 725.758,
    y: 67.0863,
    width: 747.851,
    height: 506.622,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 73.9636,
    result: "effect1_foregroundBlur_346_106"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_346_106",
    x: -20.1306,
    y: 70.5762,
    width: 792.542,
    height: 507.944,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 73.9636,
    result: "effect1_foregroundBlur_346_106"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_346_106",
    x: -200.176,
    y: 87.4952,
    width: 604.932,
    height: 494.779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 73.9636,
    result: "effect1_foregroundBlur_346_106"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomGradient);
export default __webpack_public_path__ + "static/media/BottomGradient.26849d9f7e706116edfe2246ba0517c0.svg";
export { ForwardRef as ReactComponent };